module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "containDiv"
    }
  }, [_c('div', {
    attrs: {
      "data-v-1690f989": ""
    }
  }, [_c('div', {
    staticClass: "clickMe",
    on: {
      "click": _vm.openNB
    }
  }, [_vm._v("点我直接跳过")]), _vm._v(" "), (_vm.checkStatus()) ? _c('div', {
    attrs: {
      "title": "是否显示视频"
    }
  }, [_c('video', {
    staticClass: "swiper-lazy swiper-lazy-loaded",
    staticStyle: {
      "width": "100%",
      "display": "block"
    },
    attrs: {
      "autoplay": "autoplay",
      "muted": "muted",
      "loop": "loop",
      "data-v-1690f989": "",
      "src": "https://ai.wisewater.cn/a1ssl-dk50-jfas3-df2.mp4"
    },
    domProps: {
      "muted": true
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20eeac62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/System/Welcome.vue
// module id = 1714
// module chunks = 1